module.exports = __webpack_public_path__ + "r-v3/img/teacher_group.16c5a13c.svg";